export default __webpack_public_path__ + "static/SR France - Heavy Metals - Statement-2702f9e02aa323ce0ea178a327677abd.pdf";